import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {CSSTransition} from 'react-transition-group'


class PageTwo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rotateShow: true,
            dropCardShow: true
        }
    }
    static propTypes = {
        user: PropTypes.string.isRequired
    }
    _pressToHide = () => {
        this.setState({
            rotateShow: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    rotateShow: true
                })
            }, 1000);
        })
    }
    _pressToDrop = () => {
        this.setState({
            dropCardShow: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    dropCardShow: true
                })
            }, 1000);
        })
    }
    render() {
        return <div className="page-two-wrapper">
            <div className="test-wrapper">
                <h2>状态共享</h2>
                <div>与页面一的redux共享状态：{this.props.user}</div>
            </div>
            <div className="test-wrapper">
                <h2>动画</h2>
                <CSSTransition timeout={1000} in={this.state.rotateShow} classNames='rotate-hide'>
                    <div className="rotate-hide" onClick={this._pressToHide}>点击旋转消失</div>
                </CSSTransition>
                <div className="drop-card-wrapper">
                    <CSSTransition timeout={500} in={this.state.dropCardShow} classNames='drop-card'>
                        <div className="drop-card" onClick={this._pressToDrop}>
                            点击向上卷入
                        </div>
                    </CSSTransition>
                </div>
                <div className='clear-float' />
            </div>
        </div>
        
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.pageOne.user
})

export default connect(mapStateToProps)(PageTwo)


// WEBPACK FOOTER //
// ./src/pages/PageTwo.js